import { type Enums } from '@aikoa/common'
import { useMutation } from '@tanstack/react-query'
import type { RealtorProfileFormValues } from '~/components/user/realtors/RealtorProfileForm'
import { trpc } from '~/lib/trpc'

export type CreateUserWithProfilePayload = {
  name: string
  title?: string
  email?: string
  phoneNumber?: string
  avatarUrl?: string
  company?: string
  role: Enums<'user_role'>
  inviteId?: string
}

export type CreateUserWithProfileResponse = {
  userId: string
  role: Enums<'user_role'>
  phoneNumber?: string
  email?: string
}

export function useCreateUserWithProfile() {
  return useMutation(trpc.admin.createUserWithProfile.mutationOptions())
}

export function formValuesToCreatePayload(
  values: RealtorProfileFormValues
): CreateUserWithProfilePayload {
  return {
    name: values.name,
    title: values.title || undefined,
    email: values.email || undefined,
    phoneNumber: values.phoneNumber || undefined,
    avatarUrl: values.avatarUrl || undefined,
    role: 'realtor',
  }
}
